import React, { useState, useEffect, useRef } from 'react';
import info from './Info.png';

const ConsoleModal = ({ selectedConsole, openModal, closeConsoleModal, isVisible, visibleDetails, openFullscreen, openFullscreenModal, rentDaysChange}) => {
    const [value, setValue] = useState(0);
    const sliderRef = useRef(null);
    const valueRef = useRef(null);
    useEffect(() => {
        if (selectedConsole) {
            setValue(1);
        }
    }, [selectedConsole]);

    useEffect(() => {
        updateSliderPosition();
        rentDaysChange(value);
    }, [value]);


    const handleChange = (e) => {
        setValue(Number(e.target.value));
    };

    const updateSliderPosition = () => {
        if (!sliderRef.current || !valueRef.current) return;

        const slider = sliderRef.current;
        const valueElement = valueRef.current;

        const percent = (value - slider.min) / (slider.max - slider.min);
        const sliderWidth = slider.offsetWidth;
        const thumbWidth = 20;
        const offset = percent * (sliderWidth - thumbWidth) + thumbWidth / 2;

        valueElement.style.left = `${offset}px`;
    };

    const calculatePrice = (days, pricing) => {
        if (!pricing) return 0;
        if (days <= 3) {
            return pricing.basePrices[days - 1] || 0;
        }
        return pricing.dailyRate * days;
    };
    const handleOpenOrderModal = () => {
        closeConsoleModal()
        setTimeout(openModal(), 500)
        clearTimeout()
    }

    const labels = {
        weight: "Вага",
        dimensions: "Габарити (ДхШхВ)",
        resolution: "Підтримка",
        storage: "Обсяг пам'яті",
        library: "Бібліотека",
    };
    const handleOpenFullscreenModal = (index) => {
        openFullscreen(index);
        if (openFullscreenModal) {
            openFullscreenModal();
        }
    }


    if (!selectedConsole) {
        return <div style={{display: 'none'}}></div>;
    }

    return (
        <div {...(isVisible ? { onClick: () => visibleDetails() } : {})}>
            <div className='console-modal'>
                <div style={{textAlign: 'center'}}><h2 className='console-modal-h2'>{selectedConsole.name}</h2></div>
                <div className='console-modal-images'>
                    {selectedConsole.image.map((image, index) => (
                        <img key={index} onClick={() => handleOpenFullscreenModal(index)} src={image} alt="" className={index === 0 ? "console-main-image" : "console-small-image"}/>
                    ))}
                </div>
                <div className='console-modal-description'>
                    {selectedConsole.features.map((feature, index) => {
                        if (!feature || !feature.text) return null;

                        const boldWords = feature.boldWords || [];
                        return (
                            <li className='console-modal-li' key={index}>
                                {feature.text.split(new RegExp(`(${boldWords.join("|")})`, "g")).map((part, i) =>
                                    boldWords.includes(part) ? <b key={i}>{part}</b> : part
                                )}
                            </li>
                        );
                    })}
                    <div className='info-container'>
                        {isVisible && (
                            <div className="info-block">
                                {Object.entries(selectedConsole.details).map(([key, value]) => (<div key={key}>
                                    <p><strong>{labels[key] || key}:</strong> {value}</p>
                                </div>))}
                            </div>
                        )}
                        <button onClick={() => visibleDetails()} className='console-modal-info'>
                            <img src={info} alt=""/>
                            <span>Докладніше</span>
                        </button>
                    </div>
                </div>
            </div>
            <div className='console-modal-row'>
                <div className='slider-content'>
                    <div>
                        <div className="slider-p-container">
                            <p className="slider-p">Термін оренди</p>
                        </div>
                        <div className="slider-container">
                            <div className="slider-value" ref={valueRef}>{value}</div>
                            <input
                                className="slider"
                                type="range"
                                ref={sliderRef}
                                min="1"
                                max="30"
                                value={value}
                                onChange={handleChange}
                            />
                        </div>
                    </div>
                    <div>
                        <div className='console-modal-price'>
                            <p>Вартість</p>
                            {selectedConsole?.pricing && (
                                <strong>{calculatePrice(value, selectedConsole.pricing).toLocaleString("uk-UA")} грн</strong>
                            )}
                        </div>
                    </div>
                </div>
                <button onClick={handleOpenOrderModal} className='red-btn console-modal-btn-pc'>Замовити</button>
            </div>
            <div style={{textAlign: 'center'}}>
                <button  onClick={handleOpenOrderModal} className='red-btn console-modal-btn-mb'>Замовити</button>
            </div>
        </div>
    );
};

export default ConsoleModal;
